// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"5f348bf8","643":"73024988"}[chunkId] + ".chunk.js";
};